// extracted by mini-css-extract-plugin
export default {"serviceCard":"ServiceCard_serviceCard__9iSYZ","iconContainer":"ServiceCard_iconContainer__-XLmB","cardIcon":"ServiceCard_cardIcon__8hFLc"};